import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateUser, UpdateUser, User } from '../models/user.model';
import { PagedResult } from '../models/external-sync.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private http = inject(HttpClient);
  private url = `${environment.rpsApiUrl}/api/users`;

  getAll() { return this.http.get<User[]>(this.url); }
  getPaged(page: number, pageSize: number, search?: string, roleId?: string) {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search)  params = params.set('search', search);
    if (roleId)  params = params.set('roleId', roleId);
    return this.http.get<PagedResult<User>>(`${this.url}/paged`, { params });
  }
  getById(id: string) { return this.http.get<User>(`${this.url}/${id}`); }
  create(dto: CreateUser) { return this.http.post<User>(this.url, dto); }
  update(id: string, dto: UpdateUser) { return this.http.put<User>(`${this.url}/${id}`, dto); }
  delete(id: string) { return this.http.delete(`${this.url}/${id}`); }
}
